import paper from "paper"
import {ColorLike, Vector2, Vector2Like} from "@cm/math"
import {TilingCanvasToolboxItemBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/tiling-canvas-toolbox-item-base"
import {CanvasToolboxItem} from "@common/helpers/canvas/canvas-toolbox/canvas-toolbox-item"

export class VectorItem extends TilingCanvasToolboxItemBase {
    constructor(parentItem: CanvasToolboxItem, from: Vector2Like, to: Vector2Like, color: ColorLike) {
        super(parentItem)
        this._from = Vector2.fromVector2Like(from)
        this._to = Vector2.fromVector2Like(to)
        this._line = new paper.Path.Line(this._from, this._to)
        this._line.strokeColor = new paper.Color(color.r, color.g, color.b, color.a)
        this._line.strokeWidth = 1 / this.callback.zoomLevel

        this.callback.viewChange.subscribe(() => this.updateZoomDependent())
        this.updateZoomDependent()
    }

    private updateZoomDependent() {
        this._line.strokeWidth = 1 / this.callback.zoomLevel
    }

    private _line: paper.Path
    private _from: Vector2
    private _to: Vector2
}
